const isLoggedIn = function (username, password) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include'
  }
  return fetch(`${process.env.VUE_APP_API_URL}/auth/loggedin`, requestOptions)
    .then(response => {
      return response.text()
        .then(text => {
          if (!response.ok) {
            return Promise.reject(response.statusText)
          }
          const account = text && JSON.parse(text)
          return account
        })
    })
    .then(account => {
      return account
    })
}

const login = function (username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
    credentials: 'include'
  }
  return fetch(`${process.env.VUE_APP_API_URL}/auth/login`, requestOptions)
    .then(response => {
      return response.text()
        .then(text => {
          if (!response.ok) {
            return Promise.reject(response.statusText)
          }
          const account = text && JSON.parse(text)
          return account
        })
    })
    .then(account => {
      return account
    })
}

const logout = () => {
  const requestOptions = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include'
  }
  return fetch(`${process.env.VUE_APP_API_URL}/auth/logout`, requestOptions)
    .then(response => {
      return response.text()
        .then(text => {
          if (!response.ok) {
            return Promise.reject(response.statusText)
          }
          return response
        })
    })
    .then(response => {
      return response
    })
}

export default {
  isLoggedIn,
  login,
  logout
}
